import Contacto from "./components/contacto/contacto";
import CertificadoEtica from "./components/ejercicio-profesional/certificado-etica";
import EjercicioProfesional from "./components/ejercicio-profesional/ejercicio-profesional";
import Eventos from "./components/inicio/eventos";
import Inicio from "./components/inicio/inicio";
import ComisionDirectiva from "./components/institucional/comision-directiva";
import ComisionRevisora from "./components/institucional/comision-revisora";
import QuienesSomos from "./components/institucional/quienes-somos";
import TribunalEtica from "./components/institucional/tribunal-etica";
import ObrasSociales from "./components/obras-sociales/obras-sociales";
import Profesionales from "./components/profesionales/profesionales";
import BajaMatricula from "./components/tramites/baja-matricula";
import Consultorio from "./components/tramites/consultorio";
import Matriculacion from "./components/tramites/matriculacion";
import Titulo from "./components/tramites/titulo";
import PortalHome from "./PortalHome";
import PortalHomeAnterior from "./PortalHome-ant";
import { PortalHome2 } from "./PortalHome2";
import { PortalHome3 } from "./PortalHome3";

const PortalRoutes = [
  {
    path: "/",
    element: <Inicio />,
  },
  {
    path: "home", //este es v4
    element: <PortalHome />,
  },
  {
    path: "inicio",
    element: <Inicio />,
  },
  {
    path: "profesionales",
    element: <Profesionales />,
  },
  {
    path: "contacto",
    element: <Contacto />,
  },
  {
    path: "matriculacion",
    element: <Matriculacion />,
  },
  {
    path: "consultorio",
    element: <Consultorio />,
  },
  {
    path: "titulo",
    element: <Titulo />,
  },
  {
    path: "baja-matricula",
    element: <BajaMatricula />,
  },
  {
    path: "ejercicio-profesional",
    element: <EjercicioProfesional />,
  },
  {
    path: "certificado-etica",
    element: <CertificadoEtica />,
  },
  {
    path: "eventos",
    element: <Eventos />,
  },
  {
    path: "comision-directiva",
    element: <ComisionDirectiva />,
  },
  {
    path: "quienes-somos",
    element: <QuienesSomos />,
  },
  {
    path: "obras-sociales",
    element: <ObrasSociales />,
  },
  {
    path: "tribunal-etica",
    element: <TribunalEtica />,
  },
  {
    path: "comision-revisora",
    element: <ComisionRevisora />,
  },
  {
    path: "anterior",
    element: <PortalHomeAnterior />,
  },
  {
    path: "v2",
    element: <PortalHome2 />,
  },
  {
    path: "v3",
    element: <PortalHome3 />,
  },
];

export default PortalRoutes;
